/* ═══════════════════════════════════════════════════════════════
   Skin Quer — Footer accordion
   Mobile only (≤1023px). Desktop columns are always open via CSS.
   The contact column starts open and is non-toggleable on mobile.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  var DESKTOP_QUERY = '(min-width: 1024px)';

  function init() {
    var columns = document.querySelectorAll('.sq-footer__nav-column');
    if (!columns.length) return;

    columns.forEach(function (column) {
      // Skip the contact column — it's always open on mobile, no toggle.
      if (column.classList.contains('sq-footer__nav-column--contact')) return;

      var toggle = column.querySelector('.sq-footer__nav-toggle');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        // Disable the click on desktop where columns are always open.
        if (window.matchMedia(DESKTOP_QUERY).matches) return;

        var isOpen = column.getAttribute('aria-expanded') === 'true';

        // Close any other open column (one open at a time).
        columns.forEach(function (other) {
          if (other === column) return;
          if (other.classList.contains('sq-footer__nav-column--contact')) return;
          other.setAttribute('aria-expanded', 'false');
        });

        column.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ═══════════════════════════════════════════════════════════════
   Skin Quer — Newsletter subscription (Klaviyo Client API)
   Posts directly to Klaviyo Subscribe endpoint.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  var KLAVIYO_COMPANY_ID = 'TAmzAm';
  var KLAVIYO_LIST_ID = 'UfUMr9';
  var KLAVIYO_API_REVISION = '2024-10-15';

  var form = document.querySelector('.js-newsletter-form');
  if (!form) return;

  var emailInput = form.querySelector('.js-newsletter-email');
  var submitBtn = form.querySelector('.js-newsletter-submit');
  var row = form.querySelector('.js-newsletter-row');
  var successMsg = form.querySelector('.js-newsletter-success');
  var errorMsg = form.querySelector('.js-newsletter-error');

  function showError(message) {
    errorMsg.textContent = message;
    errorMsg.hidden = false;
    successMsg.hidden = true;
  }

  function showSuccess() {
    row.hidden = true;
    successMsg.hidden = false;
    errorMsg.hidden = true;
  }

  function setLoading(isLoading) {
    submitBtn.disabled = isLoading;
    submitBtn.style.opacity = isLoading ? '0.6' : '';
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var email = emailInput.value.trim();

    if (!isValidEmail(email)) {
      showError('Por favor, insira um e-mail válido.');
      return;
    }

    setLoading(true);
    errorMsg.hidden = true;

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': KLAVIYO_API_REVISION
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            },
            custom_source: 'Footer newsletter'
          },
          relationships: {
            list: {
              data: { type: 'list', id: KLAVIYO_LIST_ID }
            }
          }
        }
      })
    }).then(function (response) {
      if (response.ok || response.status === 202) {
        showSuccess();
      } else {
        response.json().catch(function () { return null; }).then(function (errorData) {
          var message = (errorData && errorData.errors && errorData.errors[0] && errorData.errors[0].detail) || 'Não foi possível inscrever. Tente novamente em alguns instantes.';
          showError(message);
        });
      }
    }).catch(function () {
      showError('Erro de conexão. Verifique sua internet e tente novamente.');
    }).finally(function () {
      setLoading(false);
    });
  });
})();
